import React from 'react';
import PropTypes from 'prop-types';

import { Nav, Navbar } from 'react-bootstrap';

import MenuItems from './menu/MenuItems';

import { topNavbarBreakpoint } from 'config';
import autoCompleteInitialItem from 'data/autocomplete/autocomplete';
import SearchBox from './SearchBox';


const NavItems = ({ navbarPosition, navbarCollapsed }) => {

	return (
		<>
			{
				navbarPosition === 'top' || navbarPosition === 'combo' ? (
					<Navbar.Collapse in={navbarCollapsed} className="scrollbar pb-3 pb-lg-0">
						<Nav navbar>
							{' '}
							{/*<NavbarTopDropDownMenus />{' '}*/} 
							<MenuItems />
						</Nav>
					</Navbar.Collapse>
				) : (
					{/*<Nav navbar className={`align-items-center d-none d-${topNavbarBreakpoint}-block`} as="ul">
						<Nav.Item as="li">
							<SearchBox autoCompleteItem={autoCompleteInitialItem}/>
						</Nav.Item>
					</Nav>*/}
				)
			}
			{/*<TopNavRightSideNavItem />*/}
		</>
	)
}

NavItems.propTypes = {
	navbarPosition: PropTypes.string,
};

export default NavItems;


/*


<Nav
        navbar
        className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}
        as="ul">
    	{/*<Nav.Item as="li">
      		<SearchBox autoCompleteItem={autoCompleteInitialItem} />
    	</Nav.Item>
    	<MenuItems />
  	</Nav>

	*/